import React from "react";
import { Form, Field } from "react-final-form";
import { Field as VldField } from "react-final-form-html5-validation";
import classNames from "classnames";
import { toast } from "react-toastify";
import { Row, Col, FormGroup, Label, Form as BSForm, Card, CardBody, CardFooter } from "reactstrap";

import Img from "../Img";
import Button from "../Form/Button";
import Input from "../Form/Input";
import FileInput from "../Form/File";
import Condition from "../Form/Condition";
import RadioButtonGroup from "../Form/RadioButtonGroup";
import Editor from "../Form/Editor";
import Typeahead from "../Form/Typeahead";
import TrackFinder from "../Form/TrackFinder";
import SearchTypeahead from "../Form/SearchTypeahead";

import disableSubmit from "../../utils/disableSubmit";

import {
  channelCountries,
  channelTypes,
  tagTypes,
  channelStatus,
  tagContentTypes,
  sortTypes,
  startPointTypes
} from "./constants";

const ChannelForm = props => {
  let { sortType, ...restData } = props.data || {};
  sortType = sortType ? sortType.toUpperCase() : Object.keys(sortTypes)[0];
  return (
        <Form
          onSubmit={props.onSubmit}
          subscription={{
            submitting: true,
            pristine: true,
            errors: true,
            values: true
          }}
          initialValues={{
            type: Object.keys(channelTypes)[0],
            country: Object.keys(channelCountries)[0],
            sortType,
            status: Object.keys(channelStatus)[0],
            startPointType: Object.keys(startPointTypes)[0],
            coverFile: {},
            englishCoverFile: {},
            ...restData
          }}
          render={({ handleSubmit, form, submitting, pristine, errors, values }) => (
            <Card>
              <CardBody>
                <BSForm
                  id="channel-form"
                  onSubmit={e => e.preventDefault()}
                  className={classNames({ disabled: submitting })}
                >
                  <Row>
                    <Col xs="12" sm="4" lg="3">
                      <div className="card mb-2 p-2">
                        <Img
                          fill="#ccc"
                          src={
                            values.coverFile.src ||
                            (props.data && (props.data.cover || props.data.picture))
                          }
                          className="w-100 mb-3 rounded"
                        />
                        <Field
                          name="coverFile"
                          id="coverFile"
                          type="file"
                          label="کاور"
                          component={FileInput}
                          validate={value => {
                            if (value && value.file) {
                              if (value.file.type && !value.file.type.match("image.*"))
                                return "لطفاً فقط فایل عکس انتخاب کنید";
                            }
                            return undefined;
                          }}
                        />
                      </div>
                      <div className="card mb-2 p-2">
                        <Img
                          fill="#ccc"
                          src={
                            values.englishCoverFile.src ||
                            (props.data && (props.data.englishCover || props.data.picture))
                          }
                          className="w-100 mb-3 rounded"
                        />
                        <Field
                          name="englishCoverFile"
                          id="englishCoverFile"
                          type="file"
                          label="کاور انگلیسی"
                          component={FileInput}
                          validate={value => {
                            if (value && value.file) {
                              if (value.file.type && !value.file.type.match("image.*"))
                                return "لطفاً فقط فایل عکس انتخاب کنید";
                            }
                            return undefined;
                          }}
                        />
                      </div>
                      <hr />
                      <Field
                        name="status"
                        id="status"
                        type="checkbox"
                        custom="switch"
                        options={Object.keys(channelStatus).slice(0, 2)}
                        label="فعال"
                        component={Input}
                      />
                    </Col>
                    <Col>
                      <Row form>
                        <Col xs="12">
                          <Field
                            name="type"
                            id="type"
                            label="نوع کانال"
                            component={RadioButtonGroup}
                            options={channelTypes}
                          />
                        </Col>
                        <Col xs="12" lg="6">
                          <VldField
                            name="name"
                            id="name"
                            required
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            label="نام کانال"
                            component={Input}
                            placeholder="نام کانال را وارد کنید"
                          />
                        </Col>
                        <Col xs="12" lg="6">
                          <VldField
                            name="englishName"
                            id="englishName"
                            required
                            label="نام انگلیسی کانال"
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            component={Input}
                            placeholder="نام انگلیسی را وارد کنید"
                          />
                        </Col>
                        <Condition when="type" isNot="LIVE_CHANNEL">
                          <Col xs="12" lg="6">
                            <VldField
                              name="displayName"
                              id="displayName"
                              required
                              label="نام نمایشی کانال"
                              valueMissing="این قسمت نمی‌تواند خالی باشد"
                              component={Input}
                              placeholder="نام نمایشی را وارد کنید"
                            />
                          </Col>
                        </Condition>
                        <Condition when="type" is="LIVE_CHANNEL">
                          <Col xs="12" lg="6">
                            <VldField
                              name="djname"
                              id="djname"
                              required
                              valueMissing="این قسمت نمی‌تواند خالی باشد"                              
                              label="نام DJ"
                              component={Input}
                              placeholder="نام DJ را وارد کنید"
                            />
                          </Col>
                        </Condition>
                        <Col xs="12" lg="6">
                          <VldField
                            name="country"
                            id="country"
                            required
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            label="قابل دسترس در"
                            component={Input}
                            options={Object.keys(channelCountries).map(key => (
                              <option value={key} key={key}>
                                {channelCountries[key].label}
                              </option>
                            ))}
                            type="select"
                          />
                        </Col>
                        <Condition when="type" isNot="PROMOTED_CHANNEL">
                          <Col>
                            <VldField
                              name="tags"
                              id="tags"
                              required
                              label="تگ‌های کانال"
                              valueMissing="این قسمت نمی‌تواند خالی باشد"
                              component={Typeahead}
                              options={props.tags}
                              selected={values.tags}
                              placeholder="جستجو و انتخاب تگ"
                              emptyLabel="تگی پیدا نشد"
                              multiple
                              paginationText="نمایش موارد بیشتر"
                              labelKey={option =>
                                `${tagTypes[option.type]}-${option.value}${
                                option.contentType ? "(" : ""
                                }${tagContentTypes[option.contentType || "no"]}${
                                option.contentType ? ")" : ""
                                }`
                              }
                            />
                          </Col>
                        </Condition>
                        <Condition when="type" is="AUTOMATIC_CHANNEL">
                          <Col xs="12" lg="3">
                            <VldField
                              name="sortType"
                              id="sortType"
                              required
                              valueMissing="این قسمت نمی‌تواند خالی باشد"
                              label="چینش بر اساس"
                              component={Input}
                              options={Object.keys(sortTypes).map(key => (
                                <option value={key} key={key}>
                                  {sortTypes[key]}
                                </option>
                              ))}
                              type="select"
                            />
                          </Col>
                          <Col xs="12">
                            <Field
                              name="excludeTags"
                              id="excludeTags"
                              label="به جز تگ‌های"
                              component={Typeahead}
                              options={props.tags}
                              selected={values.excludeTags}
                              placeholder="جستجو و انتخاب تگ"
                              emptyLabel="تگی پیدا نشد"
                              paginationText="نمایش موارد بیشتر"
                              multiple
                              labelKey={option =>
                                `${tagTypes[option.type]}-${option.value}${
                                option.contentType ? "(" : ""
                                }${tagContentTypes[option.contentType || "no"]}${
                                option.contentType ? ")" : ""
                                }`
                              }
                            />
                          </Col>
                          <Col>
                            <VldField
                              name="startPointType"
                              id="startPointType"
                              required
                              valueMissing="این قسمت نمی‌تواند خالی باشد"
                              label="نوع نقطهٔ شروع"
                              component={Input}
                              options={Object.keys(startPointTypes).map(key => (
                                <option value={key} key={key}>
                                  {startPointTypes[key]}
                                </option>
                              ))}
                              type="select"
                            />
                          </Col>
                          <Condition
                            when="startPointType"
                            test={value =>
                              value && value.trim() && value !== null && value !== "NO"
                            }
                          >
                            <Col xs="12" md="6">
                              <FormGroup>
                                <Label>نقطهٔ شروع</Label>
                                <Field
                                  name="search"
                                  id="search"
                                  searchType={(
                                    values.startPointType || ""
                                  ).toLowerCase()}
                                  label={startPointTypes[values.startPointType]}
                                  placeholder={(values.startPoint || "").toString()}
                                  component={SearchTypeahead}
                                />
                              </FormGroup>
                            </Col>
                          </Condition>
                        </Condition>
                        <Condition when="type" is="PROMOTED_CHANNEL">
                          <Col xs="12">
                            <VldField
                              name="tracks"
                              id="tracks"
                              className="mb-3"
                              tags={props.tags}
                              tagTypes={tagTypes}
                              tagContentTypes={tagContentTypes}
                              sortTypes={sortTypes}
                              component={TrackFinder}
                            />
                          </Col>
                        </Condition>
                        <Condition when="type" is="LIVE_CHANNEL">
                          <Col xs="12">
                            <VldField
                              name="link"
                              id="link"
                              required
                              valueMissing="این قسمت نمی‌تواند خالی باشد"
                              label="لینک پخش زنده"
                              component={Input}
                              placeholder="لینک پخش زنده را وارد کنید"
                            />
                          </Col>
                        </Condition>
                        <Col xs="12">
                          <VldField
                            name="description"
                            id="description"
                            required
                            valueMissing="این قسمت نمی‌تواند خالی باشد"
                            label="توضیحات کانال"
                            placeholder="توضیحات کانال را وارد کنید"
                            component={Editor}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </BSForm>
              </CardBody>
              <CardFooter className="position-sticky-bottom bg-light">
                <Button
                  loading={submitting}
                  disabled={disableSubmit({
                    submitting,
                    pristine: false,
                    errors
                  })}
                  className="ml-3"
                  onClick={() => {
                    handleSubmit().then(response => {
                      toast.success(
                        props.data
                          ? "تغییرات با موفقیت ذخیره شد"
                          : "کانال جدید ساخته شد",
                        { toastId: "channel-saved" }
                      );
                      if (typeof props.goBack === "function") props.goBack();
                    });
                  }}
                >
                  {props.data ? `ذخیره و بازگشت` : "ساخت کانال"}
                </Button>
                {props.data && !submitting && (
                  <Button
                    outline
                    loading={submitting}
                    disabled={disableSubmit({
                      submitting,
                      pristine: false,
                      errors
                    })}
                    onClick={() => {
                      handleSubmit().then(response => {
                        toast.success(
                          props.data
                            ? "تغییرات با موفقیت ذخیره شد"
                            : "کانال جدید ساخته شد",
                          { toastId: "channel-saved" }
                        );
                      });
                    }}
                  >
                    ذخیره
                  </Button>
                )}
              </CardFooter>
            </Card>
          )}
        />
  );
};
export default ChannelForm;
